export const productCount = '/api/office/shopping/car/productCount'